export default [
    { "id": 1, "value": 1, "text": 'Sim' },
    { "id": 2, "value": 0, "text": 'Não' }
];